export default __webpack_public_path__ + "static/cart-dff5c50330a9166e8b464b94ce51cb97.png";